import React from "react"
import { FormControlLabel as MuiFormControlLabel, FormControlLabelProps } from "@mui/material"

export type PrimitiveFormControlLabelProps = FormControlLabelProps

export const PrimitiveFormControlLabel = (props: PrimitiveFormControlLabelProps) => {
	return <MuiFormControlLabel {...props} />
}
